import { Route, RouteRecord } from "vue-router";
import Vue from "vue";
import { i18n } from "@/main";

/**
 * Le titre d'une route provient soit de la page elle-même (meta.title, posé à l'exécution et
 * déjà traduit), soit d'une clé i18n déclarée statiquement dans le routeur (meta.titleKey).
 * Les routes ne peuvent pas appeler i18n.t() à l'import : elles sont évaluées avant sa création.
 */
export function getTitleFromMetadata(meta: any): string | null {
  if (!meta) {
    return null;
  }
  if (meta.title) {
    return meta.title.toString();
  }
  if (meta.titleKey) {
    return i18n.t(meta.titleKey).toString();
  }
  return null;
}

export function setTitleFromMetadata(to: Route): void {
  if (!to.meta.withoutTitle) {
    // This goes through the matched router from last to first, finding the closest route with a title.
    // eg. if we have /some/deep/nested/route and /some, /deep, and /nested have titles, nested's will be chosen.
    const nearestWithTitle = to.matched
      .slice()
      .reverse()
      .find((r: RouteRecord) => r.meta && getTitleFromMetadata(r.meta));
    if (nearestWithTitle) {
      const title = getTitleFromMetadata(nearestWithTitle.meta);
      document.title = `${title} | ${process.env.VUE_APP_NAME}`;
      new Vue().$eventHub.$emit("update-title", title);
    }
  } else if (!to.meta.withoutTitleRefresh) {
    new Vue().$eventHub.$emit("update-title", null);
  }
}

export function setIsMenuFromMetadata(to: Route) {
  if (to.meta.withoutMenu) {
    new Vue().$eventHub.$emit("toggle-menu", false);
  } else {
    new Vue().$eventHub.$emit("toggle-menu", true);
  }
}
